import React, { useState, useEffect, useRef } from 'react';
import './style.scss';
import 'react-toggle/style.css';
import domToImage from 'dom-to-image';
import { useTranslation } from 'react-i18next';
import SystemUpdateAltIcon from '@mui/icons-material/SystemUpdateAlt';

function GraphMathPopup({ isOpen, onClose, nameAction, onAddGraph }) {
  const { t } = useTranslation();
  const [showPopup, setShowPopup] = useState(isOpen);
  const [isAddImageActive, setIsAddImageActive] = useState(false);
  const [nameActionState, setNameActionState] = useState('firstContextObject');
  const [calculator, setCalculator] = useState(null);
  const calculatorContainer = useRef(null);

  useEffect(() => {
    setShowPopup(isOpen);
    if (!isOpen) {
      setCalculator(null); // Сброс калькулятора при закрытии
    }
  }, [isOpen]);

  useEffect(() => {
    if (showPopup && calculatorContainer.current) {
      const newCalculator = Desmos.GraphingCalculator(calculatorContainer.current);
      setCalculator(newCalculator);

      const handleContentLoaded = () => {
        const closeButton = document.querySelector('.dcg-tooltip-hide-area-container');
        if (closeButton) {
          closeButton.click();
        }
      };

      calculatorContainer.current.addEventListener('load', handleContentLoaded);

      return () => {
        if (calculatorContainer.current) {
          calculatorContainer.current.removeEventListener('load', handleContentLoaded);
        }
      };
    }
  }, [showPopup]);

  async function handleAddToEditor() {
    setIsAddImageActive(true);

    if (!calculator) {
      console.error('Calculator is not initialized.');
      setIsAddImageActive(false);
      return;
    }

    const state = calculator.getState();
    const stateString = JSON.stringify(state);

    const graphImage = await domToImage.toPng(document.getElementById('desmos-calculator-container'));

    onAddGraph(graphImage, stateString, nameAction);

    setIsAddImageActive(false);

    onClose();
  }

  const handleActionFunc = name => {
    setNameActionState(name);
  };

  return showPopup ? (
    <div>
      <div className={`popup-content-graph ${isAddImageActive ? 'add-image' : ''}`}>
        <button onClick={onClose} className="btn btn-icon close">
          <span className="icon icon-plus"></span>
        </button>
        <button onClick={handleAddToEditor} className="btn add-math-graph">
          {t('add-graph-notebook')}
        </button>
        <div className="title-graph">
          <h2>{t('Graph constructor')}</h2>
          <div className="block-buttons-list">
            <button
              className={nameActionState === 'firstContextObject' ? 'button-list left active' : 'button-list left'}
              onClick={() => handleActionFunc('firstContextObject')}
            >
              <SystemUpdateAltIcon size={20} />
            </button>
            <button
              className={nameActionState === 'secondContextObject' ? 'button-list right active' : 'button-list right'}
              onClick={() => handleActionFunc('secondContextObject')}
            >
              <SystemUpdateAltIcon size={20} />
            </button>
          </div>
        </div>

        <div ref={calculatorContainer} id="desmos-calculator-container"></div>
      </div>
    </div>
  ) : null;
}

export default GraphMathPopup;
